<template>
  <div class="xglist">
    <Level1 :source="2"></Level1>
  </div>
</template>
<script>
import Level1 from "./modules/Level1.vue";
export default {
  name: "xglist",
  components: {
    Level1,
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.xglist{
    height: 100%;
}</style>
